/**
 * <g-card> - Kanban Card
 *
 * A draggable card for use inside g-column.
 * Supports any HTML content as children.
 *
 * @example
 * <g-card card-id="task-123">
 *   <strong>Task Title</strong>
 *   <p>Description</p>
 * </g-card>
 *
 * @attr {string} card-id - Unique identifier (required for events)
 */
export class GCard extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.render();
  }

  render() {
    // Use Tailwind classes for all styling
    this.classList.add(
      'block', 'rounded-lg', 'p-3.5', 'mb-2', 'cursor-grab',
      'bg-base-100', 'border', 'border-base-300',
      'shadow-sm', 'transition-all', 'duration-150',
      'hover:shadow-md', 'hover:-translate-y-0.5',
      'overflow-hidden'
    );
  }
}

customElements.define('g-card', GCard);
